import './Footer.scss'

function Footer() {
    return (
        <footer>
            <p>BiMusic by Nico and Kira</p>
        </footer>
    )
}

export default Footer;